import "./App.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Sentry from "@sentry/react";
import { DialogContextProvider } from "app/components/dialog/components/DialogContextProvider";
import { SnackbarMessagesContextProvider } from "app/components/snackbar/components/SnackbarMessagesContextProvider";
import { ThemeProvider } from "app/theme/components/ThemeProvider";
import { ReactHookFormDebugContextProvider } from "app/tools/debugRHFState/components/ReactHookFormDebugContextProvider";
import { QueryClientProvider } from "app/tools/query/QueryClientProvider";
import { ProtectedRouterProvider } from "app/tools/router/ProtectedRouterProvider";
import { AuthTokenContextProvider } from "User/Authentication/components/AuthTokenContextProvider";

function App() {
  return (
    <SnackbarMessagesContextProvider>
      <QueryClientProvider>
        <AuthTokenContextProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider>
              <DialogContextProvider>
                <ReactHookFormDebugContextProvider>
                  <ProtectedRouterProvider />
                </ReactHookFormDebugContextProvider>
              </DialogContextProvider>
            </ThemeProvider>
          </LocalizationProvider>
        </AuthTokenContextProvider>
      </QueryClientProvider>
    </SnackbarMessagesContextProvider>
  );
}

const AppWithProfiler = Sentry.withProfiler(App);
export default AppWithProfiler;
